import { MarketplaceItemAttributeDisplayType } from './marketplace-item-attribute-display-type.enum';
import { MarketplaceItemAttributeValue } from './marketplace-item-attribute-value.model';
import { MarketplaceItemAttribute } from './marketplace-item-attribute.model';
import { MarketplaceItemMappingAttribute } from './marketplace-item-mapping-attribute.model';

export const MARKETPLACE_ITEM_ATTRIBUTES_MOCK: MarketplaceItemAttribute[] = [
  {
    RewardAttributeId: 44,
    DisplayName: 'Color',
    DisplayType: MarketplaceItemAttributeDisplayType.Colour,
    Values: [
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 138,
        DisplayName: 'Red',
        RewardMappingIds: 'string',
        Ordinal: 0,
        Locales: [
          {
            RewardValueId: 138,
            DisplayName: 'Red',
            LCID: 2057,
          },
          {
            RewardValueId: 138,
            DisplayName: 'Rouge',
            LCID: 3084,
          },
        ],
        AttributeMappingId: 167,
      },
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 139,
        DisplayName: 'Blue',
        RewardMappingIds: 'string',
        Ordinal: 1,
        Locales: [
          {
            RewardValueId: 139,
            DisplayName: 'Blue',
            LCID: 2057,
          },
          {
            RewardValueId: 139,
            DisplayName: 'Bleu',
            LCID: 3084,
          },
        ],
        AttributeMappingId: 167,
      },
    ],
    Locales: [
      {
        RewardAttributeId: 44,
        DisplayName: 'Color',
        LCID: 2057,
      },
      {
        RewardAttributeId: 44,
        DisplayName: 'Couleur',
        LCID: 3084,
      },
    ],
  },
  {
    RewardAttributeId: 42,
    DisplayName: 'Size',
    DisplayType: MarketplaceItemAttributeDisplayType.Free_Text,
    Values: [
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 133,
        DisplayName: 'S',
        RewardMappingIds: 'string',
        Ordinal: 0,
        Locales: [
          {
            RewardValueId: 133,
            DisplayName: 'S',
            LCID: 2057,
          },
        ],
        AttributeMappingId: 167,
      },
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 134,
        DisplayName: 'M',
        RewardMappingIds: 'string',
        Ordinal: 1,
        Locales: [
          {
            RewardValueId: 134,
            DisplayName: 'M',
            LCID: 2057,
          },
        ],
        AttributeMappingId: 167,
      },
    ],
    Locales: [
      {
        RewardAttributeId: 42,
        DisplayName: 'Size',
        LCID: 2057,
      },
      {
        RewardAttributeId: 42,
        DisplayName: 'Taille',
        LCID: 3084,
      },
    ],
  },
];

export const MARKETPLACE_ITEM_FR_ATTRIBUTES_MOCK: MarketplaceItemAttribute[] = [
  {
    RewardAttributeId: 44,
    DisplayName: 'Couleur',
    DisplayType: MarketplaceItemAttributeDisplayType.Colour,
    Values: [
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 138,
        DisplayName: 'Rouge',
        RewardMappingIds: 'string',
        Ordinal: 0,
        Locales: [
          {
            RewardValueId: 138,
            DisplayName: 'Red',
            LCID: 2057,
          },
          {
            RewardValueId: 138,
            DisplayName: 'Rouge',
            LCID: 3084,
          },
        ],
        AttributeMappingId: 167,
      },
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 139,
        DisplayName: 'Bleu',
        RewardMappingIds: 'string',
        Ordinal: 1,
        Locales: [
          {
            RewardValueId: 139,
            DisplayName: 'Blue',
            LCID: 2057,
          },
          {
            RewardValueId: 139,
            DisplayName: 'Bleu',
            LCID: 3084,
          },
        ],
        AttributeMappingId: 167,
      },
    ],
    Locales: [
      {
        RewardAttributeId: 44,
        DisplayName: 'Color',
        LCID: 2057,
      },
      {
        RewardAttributeId: 44,
        DisplayName: 'Couleur',
        LCID: 3084,
      },
    ],
  },
  {
    RewardAttributeId: 42,
    DisplayName: 'Taille',
    DisplayType: MarketplaceItemAttributeDisplayType.Free_Text,
    Values: [
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 133,
        DisplayName: 'S',
        RewardMappingIds: 'string',
        Ordinal: 0,
        Locales: [
          {
            RewardValueId: 133,
            DisplayName: 'S',
            LCID: 2057,
          },
        ],
        AttributeMappingId: 167,
      },
      {
        AttributeValue: '2026-03-18T14:58:00.000Z',
        RewardValueId: 134,
        DisplayName: 'M',
        RewardMappingIds: 'string',
        Ordinal: 1,
        Locales: [
          {
            RewardValueId: 134,
            DisplayName: 'M',
            LCID: 2057,
          },
        ],
        AttributeMappingId: 167,
      },
    ],
    Locales: [
      {
        RewardAttributeId: 42,
        DisplayName: 'Size',
        LCID: 2057,
      },
      {
        RewardAttributeId: 42,
        DisplayName: 'Taille',
        LCID: 3084,
      },
    ],
  },
];

export const MARKETPLACE_ITEM_ATTRIBUTE_MAPPING_MOCK: MarketplaceItemMappingAttribute[] = [
  {
    AttributeValues: [133, 138],
    AttributeMappingId: 167,
    StockCount: 50,
    AvailableStockCount: 39,
    DisplayName: 'S - Red',
    UnlimitedStock: false,
  },
  {
    AttributeValues: [133, 139],
    AttributeMappingId: 168,
    StockCount: 5,
    AvailableStockCount: 3,
    DisplayName: 'S - Blue',
    UnlimitedStock: false,
  },
  {
    AttributeValues: [134, 138],
    AttributeMappingId: 169,
    StockCount: 3,
    AvailableStockCount: 2,
    DisplayName: 'M - Red',
    UnlimitedStock: false,
  },
  {
    AttributeValues: [134, 139],
    AttributeMappingId: 170,
    StockCount: 45,
    AvailableStockCount: 40,
    DisplayName: 'M - Blue',
    UnlimitedStock: false,
  },
];

export const MARKETPLACE_ITEM_ATTRIBUTE_VALUE_MOCK: MarketplaceItemAttributeValue = {
  AttributeValue: '2026-03-18T14:58:00.000Z',
  RewardValueId: 0,
  DisplayName: 'Size',
  RewardMappingIds: '168',
  Ordinal: 0,
  Locales: [
    { RewardValueId: 0, DisplayName: 'Size', LCID: 2057 },
    { RewardValueId: 0, DisplayName: 'Taille', LCID: 3084 },
  ],
  AttributeMappingId: 167,
};
